// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__3isQL","legacyBtn":"MutateMid_legacyBtn__3GsOE"};